import { motion } from "framer-motion";

export default function ChromeText({ children, className = "", as: Tag = "span" }) {
  return (
    <Tag className={`chrome-text ${className}`} data-testid="chrome-text">
      {children}
    </Tag>
  );
}

export function ChromeBar({ className = "" }) {
  return <div className={`h-px chrome-border ${className}`} />;
}

export function SilverOrb({ size = 160 }) {
  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
      style={{ width: size, height: size }}
      className="relative"
    >
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background:
            "radial-gradient(circle at 30% 25%, #ffffff 0%, #d1d5db 18%, #6b7280 50%, #1f2937 85%, #000 100%)",
          boxShadow:
            "inset -10px -10px 30px rgba(0,0,0,0.8), inset 12px 12px 30px rgba(255,255,255,0.3), 0 0 60px rgba(255,255,255,0.15)",
        }}
      />
      <div
        className="absolute inset-0 rounded-full mix-blend-overlay"
        style={{
          background:
            "conic-gradient(from 0deg, transparent 0%, rgba(255,255,255,0.3) 50%, transparent 100%)",
          animation: "chrome-shimmer 8s linear infinite",
        }}
      />
    </motion.div>
  );
}
